<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import jsPDF from "jspdf";
   import autoTable from "jspdf-autotable";
   
   export default {
      page: {
         title: "Patients Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Patients Report",
            items: [
               {
                  text: "Patients Report",
                  active: true,
               },                   
            ],

            patients: [],            
            all_patients: [],            

            from: null,
            to: null,
            total: null,

            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            from_date: current_date,
            to_date: current_date,
            errors: {},          
            acpage_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchPatients();

      },

      methods: {
         fetchPatients(page_url = null) {

            this.getToken();

            let url = "clinic/patient_report?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url; 
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.patients = responseData.patients.data;
               this.all_patients = responseData.all_patients;            
            
               //this.questions = responseData.questions; 
               this.pagination = responseData.patients.links;
               this.from = responseData.patients.from;
               this.to = responseData.patients.to;
               this.total = responseData.patients.total; 
               this.clearForm(); 

            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));


         },
         clearForm() {
                        this.errors = {};  
                     },

         downloadPatientPdf(){

            let url = "clinic/patient_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "patient_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                     console.error("Error downloading PDF file:", error);
                     this.$swal("", "Failed to download PDF file", "error");
               })
               .finally(() => (this.loading = false));

         },

         downloadPatientsExcel() {
            let url = "clinic/patient_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "patient_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                     // Handle errors
                     console.error("Error downloading Excel file:", error);
                     this.$swal("", "Failed to download Excel file", "error");
               })
               .finally(() => (this.loading = false));
         },
      downloadPatientsPdfFromClient() {
            if (!this.all_patients.length) {
            this.$swal("", "No data available to download", "info");
            return;
            }

            const doc = new jsPDF();
            doc.text("Patients Report", 14, 15);

            // const headers = [["Name", "Contact", "Gender", "Place & Pincode", "Created At"]];

            const rows = this.all_patients.map((patient) => {
            const contact = `${patient.country_code || ""} ${patient.mobile || ""}\n${patient.email || ""}`;
            const gender = patient.gender === 1 ? "Male" : patient.gender === 2 ? "Female" : "Others";
            const place = `${patient.address || ""} ${patient.pincode || ""}`;
            const createdAt = patient.formatted_created_at;

            return [patient.name, contact, gender, place, createdAt];
            });

            autoTable(doc, {
               startY: 20,
               head: [["Name", "Contact", "Gender", "Place & Pincode", "Created At"]],
               body: rows,
               styles: { fontSize: 8 },
               headStyles: { fillColor: [41, 128, 185] },
               columnStyles: {
                  0: { cellWidth: 30 }, // Name
                  1: { cellWidth: 50 }, // Contact
                  2: { cellWidth: 20 }, // Gender
                  3: { cellWidth: 50 }, // Place & Pincode
                  4: { cellWidth: 40 }, // Created At
               }
            });
            doc.save("Patients_Report.pdf");
         },

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                            </div>
                     </div>
                     <div class="form-group col-lg-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="to_date" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                            </div>
                     </div>
                     
                     <!-- <div class="form-group col-lg-4">
                        <label>Fuel Station</label>
                        <select class="form-control">
                           <option value="">All</option>
                           <option value="1">Fuel Station1</option>
                           <option value="2">Fuel Station2</option>
                           <option value="3">Fuel Station3</option>
                        </select>
                     </div> -->
                     
                  </div>
                  <!----- filters area ends---->

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button"  @click="fetchPatients()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadPatientsPdfFromClient()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadPatientsExcel()">Download Excel</button>
                     </div>
                  </div>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchPatients()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchPatients()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>
                              <th>Contact</th>  
                              <th>Gender</th>
                              <th>Pincode</th>
                              <th>Address</th>
                              <th>Created At</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(patients.length)">
                           <tr v-for="patient in patients" :key="patient.id">
                              <td>{{patient.name}}</td>                       
                              <td>
                                 {{patient.country_code}} {{patient.mobile}}<br>
                                 {{patient.email}}<br>
                              </td>
                              <td v-if="patient.gender === 1">Male</td>
                              <td v-if="patient.gender === 2">Female</td>
                              <td v-if="patient.gender === 3">Others</td>
                              <th>{{patient.pincode}}</th>
                              <th>{{patient.address}}</th>
                              <td>{{patient.converted_created_at}}</td>
                              <td>
                                 <router-link :to="{ name: 'patients.details', params: {id: patient.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>

                                 <!-- <router-link :to="{ name: 'patients.edit' }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link> -->

                                 <router-link :to="{ name: 'patients.bookings' , params: {id: patient.id}}" class="btn btn-primary me-2 mb-2 btn-sm">Bookings</router-link>      

                                 <router-link :to="{ name: 'patients.records' , params: {id: patient.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Records</router-link>

                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No patients found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(patients.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchPatients(page.url + '&limit='+ listing_length + '&keyword=' + keyword)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
